import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "reduxFiles/hooks";
import { UserRole } from "types/userTypes";

interface LayoutGuardProps {
  children: React.ReactNode;
  layoutType: "admin" | "company" | "organization";
}

export const LayoutGuard = ({ children, layoutType }: LayoutGuardProps) => {
  const { user, accessToken, initialized } = useAppSelector(
    (state) => state.auth
  );

  if (!initialized) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="loader w-8 text-blue-700" />
      </div>
    );
  }

  if (!accessToken) {
    if (layoutType === "organization") {
      return <Navigate to="/auth/organization-login" replace />;
    }
    return <Navigate to="/auth/sign-in" replace />;
  }

  if (!user) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="loader w-6 text-blue-700" />
      </div>
    );
  }

  if (user?.role === UserRole.ADMIN) {
    if (layoutType !== "admin") {
      return <Navigate to="/admin/dashboard" replace />;
    }
    return <>{children}</>;
  }

  if (user?.role === UserRole.USER) {
    if (layoutType === "organization") {
      if (user.organization) {
        return <>{children}</>;
      } else {
        return <Navigate to="/company/dashboard" replace />;
      }
    }

    if (layoutType === "company") {
      return <>{children}</>;
    }

    if (layoutType === "admin") {
      if (user.organization) {
        return <Navigate to="/organization/dashboard" replace />;
      }
      return <Navigate to="/company/dashboard" replace />;
    }
  }

  return <Navigate to="/auth/sign-in" replace />;
};

export default LayoutGuard;
